import { BaseBus } from "./BaseBus";
import { TaxCodeBus } from "./TaxCodeBus";
import { CustomPricingBus } from "./CustomPricingBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";

export class v_LocationDetailBus extends BaseBus
{
  constructor(data: v_LocationDetailBus = null)
  {
      super(data);
      if(CommonFunctions.hasValue(data))
      {
          this.taxCode = new TaxCodeBus(data.taxCode);
          this.customPricing = new CustomPricingBus(data.customPricing);
          this.locationTaxCode = new TaxCodeBus(data.taxCode);
          this.warrantyEndDate = DateFunctions.getDate(data.warrantyEndDate);
      }
    }
    setTaxCode(taxCode: TaxCodeBus = null) {
        if (taxCode === null) {
            this.taxCode = new TaxCodeBus(this.locationTaxCode);
        }
        else {
            this.taxCode = new TaxCodeBus(taxCode);
        }
    }

    clearTaxCode() {
        this.taxCode = new TaxCodeBus();
    }
  locationId: any;
  locationName: string;
  customerName: string;
  phone: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  stateProvince: string;
  postalCode: string;
  county: string;
  countryCd: string;
  address: string;
  cityStateZip: string;
  lat: number;
  lng: number;
  isActive: boolean;
  customerId: any;
  geographyId: any;
  accountManager: any;
  acctManName: string;
  acctManMainNumber: string;
  acctManCellNumber: string;
  billingAddressLine1: string;
  billingAddressLine2: string;
  billingCity: string;
  billingStateProvince: string;
  billingPostalCode: string;
  billingAddressName: string;
  billingCounty: string;
  billingCountryCd: string;
  billingGeographyId: any;
  taxCodeId: any;
  termId: any;
  salespersonId: any;
  inventoryLocationId: any;
  isExempt: boolean;
  useInternationalCost: boolean;
  taxCode: TaxCodeBus;
  customPricing: CustomPricingBus;
    nte: number;
    locationTaxCode: TaxCodeBus;
    reqWorkNum: boolean;
    divisionId: any;
    payLocalTaxCode: string;
    onWatchtower: boolean;
    companyId: any;
    isActiveCustomer: boolean;
    underConstruction: boolean;
    warrantyEndDate: Date;
    sageCust: string;
    dispatchRequiresPO: boolean;
    billingEmail: string;
    fullContract: boolean;
    laborInventoryLocationIds: string[];
}
